import { ProtocolVersionForKeyParams } from './ProtocolVersionForKeyParams';
import { SNRootKeyParams } from './RootKeyParams';
export function Create001KeyParams(keyParams) {
    return CreateAnyKeyParams(keyParams);
}
export function Create002KeyParams(keyParams) {
    return CreateAnyKeyParams(keyParams);
}
export function Create003KeyParams(keyParams) {
    return CreateAnyKeyParams(keyParams);
}
export function Create004KeyParams(keyParams) {
    return CreateAnyKeyParams(keyParams);
}
export function CreateAnyKeyParams(keyParams) {
    if ('content' in keyParams) {
        throw Error('Raw key params shouldnt have content; perhaps you passed in a SNRootKeyParams object.');
    }
    return new SNRootKeyParams(keyParams);
}
export function KeyParamsFromApiResponse(response, identifier) {
    const rawKeyParams = {
        identifier: identifier || response.identifier,
        pw_cost: response.pw_cost,
        pw_nonce: response.pw_nonce,
        pw_salt: response.pw_salt,
        version: ProtocolVersionForKeyParams(response),
        origination: response.origination,
        created: response.created,
    };
    return CreateAnyKeyParams(rawKeyParams);
}
